export default {

    getBrowserInterfaceSize() {
        let pageWidth = window.innerWidth;
        let pageHeight = window.innerHeight;

        if (typeof pageWidth != "number") {
            //在标准模式下面
            if (document.compatMode === "CSS1Compat") {
                pageWidth = document.documentElement.clientWidth;
                pageHeight = document.documentElement.clientHeight;
            } else {
                pageWidth = document.body.clientWidth;
                pageHeight = window.body.clientHeight;
            }
        }

        return {
            pageWidth: pageWidth,
            pageHeight: pageHeight,
        }
    }
}